export const getCategoryDropdown = (categoryList) => {
    return Object.values(categoryList).map((item) => {
        return {
            label: item.Title,
            value: item.ID,
        };
    });
};
export const getCategoryFromID = (id, categoryList) => {
    return categoryList[id];
};
export const createCategoryDropdownFromTree = (categoryTree, config) => {
    // Config
    const startingLevel =
        typeof config.startingLevel != 'undefined' ? config.startingLevel : 0;
    const ignoredLevels =
        typeof config.ignoredLevels != 'undefined' ? config.ignoredLevels : [];

    // Builder
    let list = [];
    const recursiveTree = (rawObject, level) => {
        const theList = Object.values(rawObject);

        theList.sort((a, b) => {
            var x = a.Title.toLowerCase();
            var y = b.Title.toLowerCase();
            return x < y ? -1 : x > y ? 1 : 0;
        });

        theList.map((node) => {
            const displayMinus = level >= 0 ? level : 0;

            if (
                ignoredLevels &&
                ignoredLevels.length > 0 &&
                ignoredLevels.indexOf(level) > -1
            ) {
                // Do nothing
            } else {
                list.push({
                    value: node.ID,
                    label: '-'.repeat(displayMinus) + ' ' + node.Title,
                });
            }

            if (typeof node.Children != 'undefined') {
                recursiveTree(node.Children, level + 1);
            }
        });
    };

    recursiveTree(categoryTree, startingLevel);

    return list;
};
